<template>
  <view-person :system="true"/>
</template>

<script>
import viewPerson from "@/views/people/viewPerson";
export default {
  components: { viewPerson }
};
</script> 